import type { LabelAndIcon } from '@base/types';
import type { CharacterFormSchema } from './schema';

export const MODEL_PROVIDER_NAMES = [
  'openai',
  'deepseek',
  'anthropic',
  'claude_vertex',
  'grok',
  'groq',
  'llama_cloud',
  'llama_local',
  'ollama',
  'google',
  'redpill',
  'openrouter',
  'heurist',
  'together',
  'eternalai',
  'galadriel',
  'falai',
  'gaianet',
  'ali_bailian',
  'volengine',
  'nanogpt',
  'hyperbolic',
  'venice',
  'akash_chat_api',
  'livepeer',
  'mistral',
  'nineteen_ai',
  'infera',
] as const;

export const MODEL_PROVIDER_NAMES_MAP: Record<
  CharacterFormSchema['modelProvider'],
  LabelAndIcon
> = {
  openai: {
    label: 'OpenAI',
    icon: '',
  },
  deepseek: {
    label: 'DeepSeek',
    icon: '',
  },
  anthropic: {
    label: 'Anthropic',
    icon: '',
  },
  claude_vertex: {
    label: 'Claude Vertex',
    icon: '',
  },
  grok: {
    label: 'Grok',
    icon: '',
  },
  groq: {
    label: 'Groq',
    icon: '',
  },
  llama_cloud: {
    label: 'LlamaCloud',
    icon: '',
  },
  llama_local: {
    label: 'LlamaLocal',
    icon: '',
  },
  ollama: {
    label: 'Ollama',
    icon: '',
  },
  google: {
    label: 'Google',
    icon: '',
  },
  redpill: {
    label: 'RedPill',
    icon: '',
  },
  openrouter: {
    label: 'OpenRouter',
    icon: '',
  },
  heurist: {
    label: 'Heurist',
    icon: '',
  },
  together: {
    label: 'Together',
    icon: '',
  },
  eternalai: {
    label: 'EternalAI',
    icon: '',
  },
  galadriel: {
    label: 'Galadriel',
    icon: '',
  },
  falai: {
    label: 'FalAI',
    icon: '',
  },
  gaianet: {
    label: 'GaiaNet',
    icon: '',
  },
  ali_bailian: {
    label: 'Ali Bailian',
    icon: '',
  },
  volengine: {
    label: 'VolEngine',
    icon: '',
  },
  nanogpt: {
    label: 'NanoGPT',
    icon: '',
  },
  hyperbolic: {
    label: 'Hyperbolic',
    icon: '',
  },
  venice: {
    label: 'Venice',
    icon: '',
  },
  akash_chat_api: {
    label: 'Akash Chat API',
    icon: '',
  },
  livepeer: {
    label: 'Livepeer',
    icon: '',
  },
  mistral: {
    label: 'Mistral',
    icon: '',
  },
  nineteen_ai: {
    label: 'Nineteen AI',
    icon: '',
  },
  infera: {
    label: 'Infera',
    icon: '',
  },
};

export const SECRETS_MODEL_PROVIDER_MAP: Record<
  CharacterFormSchema['modelProvider'],
  Record<string, string>
> = {
  deepseek: {
    DEEPSEEK_API_KEY: '',
  },
  openai: {
    OPENAI_API_KEY: '',
  },
  anthropic: {
    ANTHROPIC_API_KEY: '',
  },
  google: {
    GOOGLE_GENERATIVE_AI_API_KEY: '',
  },
  claude_vertex: { CLAUDE_VERTEX_API_KEY: '' },
  grok: {
    GROK_API_KEY: '',
  },
  groq: {
    GROQ_API_KEY: '',
  },
  llama_cloud: { LLAMA_CLOUD_API_KEY: '' },
  llama_local: {
    LLAMA_LOCAL_API_KEY: '',
  },
  ollama: {
    OLLAMA_API_KEY: '',
  },
  redpill: {
    REDPILL_API_KEY: '',
  },
  openrouter: {
    OPENROUTER_API_KEY: '',
  },
  heurist: {
    HEURIST_API_KEY: '',
  },
  together: { TOGETHER_API_KEY: '' },
  eternalai: {
    ETERNALAI_API_KEY: '',
  },
  galadriel: { GALADRIEL_API_KEY: '' },
  falai: {
    FAL_API_KEY: '',
  },
  gaianet: {
    GAIANET_SERVER_URL: '',
  },
  ali_bailian: { ALI_BAILIAN_API_KEY: '' },
  volengine: {
    VOLENGINE_API_URL: '',
  },
  nanogpt: {
    NANOGPT_API_KEY: '',
  },
  hyperbolic: {
    HYPERBOLIC_API_KEY: '',
  },
  venice: {
    VENICE_API_KEY: '',
  },
  akash_chat_api: {
    AKASH_CHAT_API_KEY: '',
  },
  livepeer: {
    LIVEPEER_GATEWAY_URL: '',
  },
  mistral: {
    MISTRAL_API_KEY: '',
  },
  nineteen_ai: {
    NINETEEN_AI_API_KEY: '',
  },
  infera: {
    INFERA_API_KEY: '',
  },
};
